import React, { useMemo } from "react";

const Sparkline = ({
  data,
  width = 96,
  height = 28,
  color = "#5B7CFF",
  strokeWidth = 1.5,
  fill = true,
  idSuffix
}) => {
  const { line, area, gradId } = useMemo(() => {
    if (!data || data.length === 0) return { line: "", area: "", gradId: "" };
    const values = data.map(d =>
      typeof d === "number" ? d : d.value != null ? d.value : d.y != null ? d.y : 0
    );
    const min = Math.min(...values);
    const max = Math.max(...values);
    const range = max - min || 1;
    const stepX = width / Math.max(1, values.length - 1);
    const pts = values.map((v, i) => {
      const x = i * stepX;
      const y = height - ((v - min) / range) * (height - 4) - 2;
      return [x, y];
    });
    const linePath = pts
      .map((p, i) => (i === 0 ? "M" : "L") + p[0].toFixed(1) + "," + p[1].toFixed(1))
      .join(" ");
    const areaPath =
      linePath + " L " + width.toFixed(1) + "," + height + " L 0," + height + " Z";
    // ID estável baseado em props (sem Math.random pra evitar re-render diff)
    const seed =
      color.charCodeAt(1) +
      values.length +
      Math.round(width) +
      Math.round(height) +
      (idSuffix ? String(idSuffix).charCodeAt(0) : 0);
    return { line: linePath, area: areaPath, gradId: "muv2-spk-" + seed };
  }, [data, width, height, color, idSuffix]);

  if (!line) return null;

  return (
    <svg
      width={width}
      height={height}
      viewBox={"0 0 " + width + " " + height}
      style={{ display: "block" }}
      preserveAspectRatio="none"
    >
      {fill && (
        <defs>
          <linearGradient id={gradId} x1="0" x2="0" y1="0" y2="1">
            <stop offset="0%" stopColor={color} stopOpacity={0.4} />
            <stop offset="100%" stopColor={color} stopOpacity={0} />
          </linearGradient>
        </defs>
      )}
      {fill && <path d={area} fill={"url(#" + gradId + ")"} />}
      <path
        d={line}
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Sparkline;
